import { useEffect, useRef, useState } from "react";

/**
 * Wraps children and adds `is-visible` when the block enters the viewport.
 */
const ScrollReveal = ({
  children,
  className = "",
  threshold = 0.12,
  rootMargin = "0px 0px -8% 0px",
}) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || visible) {
      return undefined;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setVisible(true);
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold, rootMargin },
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold, rootMargin, visible]);

  return (
    <div
      ref={ref}
      className={`reveal-on-scroll${visible ? " is-visible" : ""} ${className}`.trim()}
    >
      {children}
    </div>
  );
};

export default ScrollReveal;
